import { Component, input, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiButton, TuiIcon } from '@taiga-ui/core';

export interface DynamicEntityListItem {
	id: string;
	name: string;
	[key: string]: any;
}

@Component({
	selector: 'ctx-dynamic-entity-list',
	templateUrl: 'dynamic-entity-list.component.html',
	styleUrl: 'dynamic-entity-list.component.scss',
	imports: [TuiButton, TuiIcon, TranslocoModule],
})
export class DynamicEntityListComponent<T extends DynamicEntityListItem> {
	/**
	 * Array of entities to display in the list
	 */
	readonly items = input.required<T[]>();

	/**
	 * Label for the "Add" button
	 */
	readonly addButtonLabel = input<string>('action.add');

	/**
	 * Empty state message (optional)
	 */
	readonly emptyMessage = input<string | null>(null);

	/**
	 * Emitted when an item should be removed
	 */
	readonly remove = output<T>();

	/**
	 * Emitted when the "Add" button is clicked
	 */
	readonly add = output<void>();

	readonly onRemove = (item: T) => this.remove.emit(item);

	readonly onAdd = () => this.add.emit();
}
